import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1920",
  height: "15.287",
  viewBox: "0 0 1920 15.287"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0,795.971H1920V780.685",
    transform: "translate(0 -780.685)",
    fill: "#181919"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["section-spacer--bar", _ctx.align])
  }, _hoisted_2, 2))
}